var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "mt-3",
      on: {
        submit: function ($event) {
          $event.preventDefault()
        },
      },
    },
    [
      _c("div", { staticClass: "card p-3 mb-3" }, [
        _c("h4", [_vm._v("Decoration")]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-4" },
            [
              _c("validated-input", {
                attrs: {
                  label: "Name",
                  name: `Name`,
                  validate: "required|max:40",
                },
                model: {
                  value: _vm.item.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.item, "name", $$v)
                  },
                  expression: "item.name",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-4" },
            [
              _c("validated-input", {
                attrs: {
                  label: "Decoration Id",
                  name: `decorationId`,
                  validate: "numeric|max:40",
                },
                model: {
                  value: _vm.item.decorationId,
                  callback: function ($$v) {
                    _vm.$set(_vm.item, "decorationId", $$v)
                  },
                  expression: "item.decorationId",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-4" },
            [
              _c("validated-input", {
                attrs: {
                  label: "Lead Time",
                  validate: "numeric",
                  optional: true,
                  mask: "##",
                },
                model: {
                  value: _vm.item.leadTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.item, "leadTime", $$v)
                  },
                  expression: "item.leadTime",
                },
              }),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-4" },
            [
              _c("validated-input", {
                attrs: {
                  label: "Rush Lead Time",
                  validate: "numeric",
                  optional: true,
                  mask: "##",
                },
                model: {
                  value: _vm.item.rushLeadTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.item, "rushLeadTime", $$v)
                  },
                  expression: "item.rushLeadTime",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-4" },
            [
              _c(
                "b-form-group",
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-between align-items-center",
                    },
                    [
                      _c("label", [_vm._v("Geometry")]),
                      _c("small", [_vm._v("optional")]),
                    ]
                  ),
                  _c("b-form-select", {
                    attrs: {
                      options: [
                        "rectangle",
                        "rectangular",
                        "square",
                        "circle",
                        "circular",
                        "other",
                      ],
                      name: "geometry",
                    },
                    model: {
                      value: _vm.item.geometry,
                      callback: function ($$v) {
                        _vm.$set(_vm.item, "geometry", $$v)
                      },
                      expression: "item.geometry",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-4" },
            [
              _c(
                "b-form-group",
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-between align-items-center",
                    },
                    [
                      _c("label", [_vm._v("Uom")]),
                      _c("small", [_vm._v("optional")]),
                    ]
                  ),
                  _c("b-form-select", {
                    attrs: {
                      options: ["inches", "other", "stitches", "colors"],
                      name: "geometry",
                    },
                    model: {
                      value: _vm.item.uom,
                      callback: function ($$v) {
                        _vm.$set(_vm.item, "uom", $$v)
                      },
                      expression: "item.uom",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-4" },
            [
              ["circle", "circular"].includes(_vm.item.geometry)
                ? _c("validated-input", {
                    attrs: { label: "Diameter", validate: "decimal" },
                    model: {
                      value: _vm.item.diameter,
                      callback: function ($$v) {
                        _vm.$set(_vm.item, "diameter", $$v)
                      },
                      expression: "item.diameter",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "row" }, [
          ["rectangle", "rectangular", "square"].includes(_vm.item.geometry)
            ? _c(
                "div",
                { staticClass: "col-md-4" },
                [
                  _c("validated-input", {
                    attrs: {
                      label: "Width",
                      validate: "decimal:2|max_value:1000",
                    },
                    model: {
                      value: _vm.item.width,
                      callback: function ($$v) {
                        _vm.$set(_vm.item, "width", $$v)
                      },
                      expression: "item.width",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          ["rectangle", "rectangular"].includes(_vm.item.geometry)
            ? _c(
                "div",
                { staticClass: "col-md-4" },
                [
                  _c("validated-input", {
                    attrs: {
                      label: "Height",
                      validate: "decimal:2|max_value:1000",
                    },
                    model: {
                      value: _vm.item.height,
                      callback: function ($$v) {
                        _vm.$set(_vm.item, "height", $$v)
                      },
                      expression: "item.height",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-4" },
            [
              _c("validated-input", {
                attrs: {
                  label: "Decoration Units Max",
                  name: `decorationUnitsMax`,
                  validate: "required",
                  "help-options": {
                    content:
                      "This is the max number of decoration units for this decoration/location combination.",
                    html: true,
                  },
                },
                model: {
                  value: _vm.item.decoration_units_max,
                  callback: function ($$v) {
                    _vm.$set(_vm.item, "decoration_units_max", $$v)
                  },
                  expression: "item.decoration_units_max",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-4" },
            [
              _c("validated-input", {
                attrs: {
                  label: "Decoration Units Included",
                  name: `decorationUnitsIncluded`,
                  validate: "numeric|max:7500",
                  "help-options": {
                    content:
                      "The number of included decoration units. For example, if 1 color decoration is included set value to “1”. If 7,500 stiches are included set value to “7500”",
                    html: true,
                  },
                },
                model: {
                  value: _vm.item.decoration_units_included,
                  callback: function ($$v) {
                    _vm.$set(_vm.item, "decoration_units_included", $$v)
                  },
                  expression: "item.decoration_units_included",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-4" },
            [
              _c("validated-input", {
                attrs: {
                  label: "Decoration Units Included Uom",
                  options: _vm.optionsUnits,
                  type: "select",
                  "help-options": {
                    content:
                      "Values are enumerated: {Colors, Inches, Other, Stitches, SquareInches }.",
                    html: true,
                  },
                },
                model: {
                  value: _vm.item.decoration_units_included_uom,
                  callback: function ($$v) {
                    _vm.$set(_vm.item, "decoration_units_included_uom", $$v)
                  },
                  expression: "item.decoration_units_included_uom",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      !_vm.itemParent && !_vm.item._id
        ? _c(
            "div",
            { staticClass: "card p-3 mb-4" },
            [
              _c("autocomplete-input", {
                attrs: {
                  path: `/products/${_vm.product._id}/locations/all`,
                  name: "Decoration Locations",
                  placeholder: "Select locations",
                  required: true,
                  multiple: true,
                  isObject: "",
                  "track-by": "_id",
                  label: "name",
                  loadOnFocus: "",
                  "options-v": [],
                },
                model: {
                  value: _vm.item.locations,
                  callback: function ($$v) {
                    _vm.$set(_vm.item, "locations", $$v)
                  },
                  expression: "item.locations",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("array-card", {
        staticClass: "card mb-3 p-3",
        attrs: {
          "default-item": {
            name: "",
            hex: "",
            colorId: "",
            colorValue: "",
            system: "",
          },
          paginate: _vm.item.colors && _vm.item.colors.length > 10,
          "per-page": 10,
          minDeleteSize: 0,
          heading: "Colors",
          "heading-class": "h4",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (propsColors) {
              return [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-6" },
                    [
                      _c("validated-input", {
                        staticClass: "mr-2",
                        attrs: { label: "Name", validate: "required" },
                        model: {
                          value: propsColors.item.name,
                          callback: function ($$v) {
                            _vm.$set(propsColors.item, "name", $$v)
                          },
                          expression: "propsColors.item.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-md-6" },
                    [
                      _c("validated-input", {
                        staticClass: "mr-2",
                        attrs: {
                          validate: {
                            regex: /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/,
                          },
                          description: "Example: #000000",
                          label: "Hex",
                        },
                        model: {
                          value: propsColors.item.hex,
                          callback: function ($$v) {
                            _vm.$set(propsColors.item, "hex", $$v)
                          },
                          expression: "propsColors.item.hex",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-md-6" },
                    [
                      _c("validated-input", {
                        staticClass: "mr-2",
                        attrs: {
                          type: "select",
                          options: _vm.colorsSystems,
                          label: "System",
                        },
                        model: {
                          value: propsColors.item.system,
                          callback: function ($$v) {
                            _vm.$set(propsColors.item, "system", $$v)
                          },
                          expression: "propsColors.item.system",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-md-6" },
                    [
                      _c("validated-input", {
                        staticClass: "mr-2",
                        attrs: { label: "Color Value", validate: "required" },
                        model: {
                          value: propsColors.item.colorValue,
                          callback: function ($$v) {
                            _vm.$set(propsColors.item, "colorValue", $$v)
                          },
                          expression: "propsColors.item.colorValue",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-md-6" },
                    [
                      _c("validated-input", {
                        staticClass: "mr-2",
                        attrs: { readonly: true, label: "Color Id" },
                        model: {
                          value: propsColors.item.colorId,
                          callback: function ($$v) {
                            _vm.$set(propsColors.item, "colorId", $$v)
                          },
                          expression: "propsColors.item.colorId",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            },
          },
        ]),
        model: {
          value: _vm.item.colors,
          callback: function ($$v) {
            _vm.$set(_vm.item, "colors", $$v)
          },
          expression: "item.colors",
        },
      }),
      _c("div", { staticClass: "card p-3 mb-4" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "card p-3 bg-light" },
          [
            _c("UploadButton", {
              staticClass: "my-2",
              attrs: {
                accept: "*",
                hasUploadFromLink: true,
                folder: _vm.uploadFolder,
                hasImageType: false,
                resize: "300",
                compress: _vm.compress,
                isResizeToSquare: true,
                visibleAttached: !_vm.item._id,
                uploadOnly: !!_vm.item._id,
              },
              on: {
                add: function ($event) {
                  return _vm.saveMedia($event)
                },
                remove: _vm.deleteMedia,
              },
              scopedSlots: _vm._u([
                {
                  key: "settings",
                  fn: function (props) {
                    return [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center mb-2" },
                        [
                          _c(
                            "div",
                            { staticClass: "custom-control custom-checkbox" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.compress,
                                    expression: "compress",
                                  },
                                ],
                                staticClass: "custom-control-input",
                                attrs: {
                                  id: `styled-checkbox`,
                                  type: "checkbox",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.compress)
                                    ? _vm._i(_vm.compress, null) > -1
                                    : _vm.compress,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.compress,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.compress = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.compress = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.compress = $$c
                                    }
                                  },
                                },
                              }),
                              _c(
                                "label",
                                {
                                  staticClass: "custom-control-label",
                                  attrs: { for: `styled-checkbox` },
                                },
                                [_vm._v("Compress")]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.medias,
                callback: function ($$v) {
                  _vm.medias = $$v
                },
                expression: "medias",
              },
            }),
          ],
          1
        ),
      ]),
      _vm.error
        ? _c("div", { staticClass: "row" }, [
            _c("span", { staticClass: "col-md-12 text-danger" }, [
              _vm._v(_vm._s(_vm.error.message)),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "mt-3 d-flex align-center justify-content-end" },
        [
          _c(
            "b-btn",
            {
              staticClass: "btn btn-light mr-2",
              attrs: { variant: "primary" },
              on: { click: _vm.cancel },
            },
            [_vm._v(" Close ")]
          ),
          _c(
            "b-btn",
            {
              attrs: {
                variant: "primary",
                disabled: _vm.errors.any() || _vm.pending,
              },
              on: { click: _vm.submit },
            },
            [
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.pending,
                    expression: "pending",
                  },
                ],
                staticClass: "far fa-spinner-third fa-spin text-white",
              }),
              _vm._v("\n      Save\n    "),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", {}, [_c("h4", [_vm._v("Image")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }